import { useSuspenseQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'

import { portfolio } from '../../queries/user-queries'
import type { PortfolioItem } from '../../schemas/portfolio'

export const usePortfolioItems = (userId: number) =>
  useSuspenseQuery<PortfolioItem[]>({
    ...portfolio.all(userId),
    queryFn: async () => {
      const data = await getRequest<PortfolioItem[]>(`/portfolio/user/${userId}`)
      if (!data) throw new Error(`No portfolio items for ${userId} found`)
      return data
    },
  })
